import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="flex justify-between h-16" data-id="element-186">
          <div className="flex items-center" data-id="element-187">
            <div className="flex-shrink-0 flex items-center" data-id="element-188">
              <span className="text-2xl font-bold text-blue-800" data-id="element-189">
                Max Cap Securities
              </span>
            </div>
          </div>
          {/* Desktop nav */}
          <nav className="hidden md:flex space-x-8 items-center" data-id="element-190">
            <a href="#home" className="text-gray-700 hover:text-blue-800 px-3 py-2 text-sm font-medium" data-id="element-191">
              Home
            </a>
            <a href="#services" className="text-gray-700 hover:text-blue-800 px-3 py-2 text-sm font-medium" data-id="element-192">
              Services
            </a>
            <a href="#about" className="text-gray-700 hover:text-blue-800 px-3 py-2 text-sm font-medium" data-id="element-193">
              About Us
            </a>
            <a href="#compliance" className="text-gray-700 hover:text-blue-800 px-3 py-2 text-sm font-medium" data-id="element-194">
              Compliance
            </a>
            <a href="#contact" className="text-gray-700 hover:text-blue-800 px-3 py-2 text-sm font-medium" data-id="element-195">
              Contact
            </a>
            <a href="https://www.tradejini.com/login" target="_blank" rel="noopener noreferrer" className="bg-blue-800 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700" data-id="element-196">
              Login
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-197">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-800" data-id="element-198">
              <span className="sr-only" data-id="element-199">Open main menu</span>
              {isMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-200" /> : <MenuIcon className="block h-6 w-6" data-id="element-201" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu, show/hide based on menu state */}
      {isMenuOpen && <div className="md:hidden" data-id="element-202">
          <div className="pt-2 pb-3 space-y-1 bg-white" data-id="element-203">
            <a href="#home" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-800" data-id="element-204">
              Home
            </a>
            <a href="#services" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-800" data-id="element-205">
              Services
            </a>
            <a href="#about" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-800" data-id="element-206">
              About Us
            </a>
            <a href="#compliance" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-800" data-id="element-207">
              Compliance
            </a>
            <a href="#contact" className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-800" data-id="element-208">
              Contact
            </a>
            <a href="https://www.tradejini.com/login" target="_blank" rel="noopener noreferrer" className="block px-3 py-2 text-base font-medium text-blue-800 hover:bg-gray-50" data-id="element-209">
              Login
            </a>
          </div>
        </div>}
    </header>;
}